import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#333333", // Gris muy oscuro para el menú y botones
    },
    secondary: {
      main: "#555555", // Otro gris para selecciones secundarias
    },
    background: {
      default: "#f5f5f5", // Color de fondo por defecto
    },
  },
});

export default theme;
